module.exports = __webpack_public_path__ + "static/media/cs.8dae5765.svg";